/**
 * i18n Configuration
 *
 * Configures i18next for Arabic/English translation with URL-based language detection.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English translations
import enCommon from './locales/en/common.json';
import enLanding from './locales/en/landing.json';
import enTerms from './locales/en/terms.json';
import enSeo from './locales/en/seo.json';

// Arabic translations
import arCommon from './locales/ar/common.json';
import arLanding from './locales/ar/landing.json';
import arTerms from './locales/ar/terms.json';
import arSeo from './locales/ar/seo.json';

const resources = {
  en: {
    common: enCommon,
    landing: enLanding,
    terms: enTerms,
    seo: enSeo,
  },
  ar: {
    common: arCommon,
    landing: arLanding,
    terms: arTerms,
    seo: arSeo,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'landing', 'terms', 'seo'],

    detection: {
      // Detect from URL path first, then localStorage
      order: ['path', 'localStorage'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
